import { TypeOf, yup } from '@guiker/yup-util'

import { Ontario } from '../../../entity'

export const additionalTerms = yup.object<Omit<Ontario.AdditionalTerms, 'completed'>>({
  hasAdditionalTerms: yup.boolean().required(),
})

export type AdditionalTerms = TypeOf<typeof additionalTerms>
